<template>
  <div class="register">
    <div id="register" class="sec">
      <v-container>
        <v-row justify="center">
          <div class="display-2 head" data-aos="fade-up">Registration</div>
        </v-row>

        <v-card
          flat
          rounded="lg"
          data-aos="fade-up"
        >
          <v-row>
            <v-col
              cols="6"
              class="ma-0 pa-0 hidden-sm-and-down"
            >
              <v-img
                width="100%"
                height="100%"
                class="left-image"
                src="@/assets/images/others/login.jpg"
              ></v-img>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6">
              <div class="form">
                <v-form>
                  <v-text-field
                    label="Email"
                  ></v-text-field>
                  <v-text-field
                    label="Phone number (optional)"
										type="number"
                  ></v-text-field>
									<v-text-field
                    label="Password"
										type="password"
                  ></v-text-field>
									<v-text-field
                    label="Confirm password"
										type="password"
                  ></v-text-field>
                </v-form>

								<v-checkbox
                  v-model="agree"
                  light
                >
                  <template slot="label">
                    <div slot='label'>I agree with the <a @click.stop href="/">Terms &amp; Conditions</a></div>
                  </template>
                </v-checkbox>

                <v-card-actions>
                  <v-btn
                    rounded
                    depressed
                    x-large
                    color="#c2dffc"
                    min-width="40%"
                    class="blue--text text--darken-2"
                  >
                    Login
                  </v-btn>
                  <v-btn
                    rounded
                    depressed
                    x-large
                    color="#1d87fd"
                    min-width="40%"
                    class="white--text"
                  >
                    Cancel
                  </v-btn>
                </v-card-actions>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "Register",
  components: {
  },
  data() {
    return {
			agree: false
    }
  },
  mounted() {
    //
  },
  methods: {
		//
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

.form {
  padding: 10%;
}

.left-image {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
</style>